/*
 * @Author: fangpu
 * @Date: 2023-08-16 16:50:50
 * @LastEditors: fangpu
 * @LastEditTime: 2023-08-17 10:43:44
 * @Description: 描述一下咯
 * @@Copyrigh: © 2020 杭州杰竞科技有限公司 版权所有
 */
import CONFIG from '@/common/config';
import Bridge from '@/common/bridge';
import getUrlParam from './getUrlParam';
import { isXiaoMaiAndroidApp, isXiaoMaiIOSApp } from '@/common/utils/getPlaform';

/**
 * app中保存活动兑换的跳转
 * @param broadcastId 活动Id
 */
export default function appSuccess(broadcastId: string): void {
  const version = getUrlParam('vn') || getUrlParam('v');

  function isNewVersion(currentVersion: String, lowestVersion: String): Boolean {
    const currentArr = currentVersion.split('.').map(item => { return Number(item) });
    const lowestArr = lowestVersion.split('.').map(item => { return Number(item) });
    if (currentArr[0] > lowestArr[0]) {
      return true;
    }
    if (currentArr[0] < lowestArr[0]) {
      return false;
    }

    if (currentArr[1] > lowestArr[1]) {
      return true;
    }
    if (currentArr[1] < lowestArr[1]) {
      return false;
    }

    if (currentArr[2] >= lowestArr[2]) {
      return true;
    }
    if (currentArr[2] < lowestArr[2]) {
      return false;
    }
    return true;
  }
  const env: string = process.env.VUE_APP_DEPLOY_ENV as string;
  const url: string = (CONFIG.appSuccessUrl as any)[env]
  if (isNewVersion((version as string), '4.13.0')) {
    if (isXiaoMaiIOSApp()) {
      Bridge.callHandler((Api: any) => {
        Api.openUrl({ url, type: 6 });
      });
    }
    if (isXiaoMaiAndroidApp()) {
      Bridge.callHandler((Api: any) => {
        Api.openUrl({ url });
      });
      Bridge.callHandler((Api: any) => {
        Api.exit();
      });
    }
  } else {
    if (isNewVersion((version as string), '4.3.2')) {
      if (isXiaoMaiIOSApp()) {
        Bridge.callHandler((Api: any) => {
          Api.openUrl({ url: `xmzj://b/show/detail?broadcastId=${broadcastId}` });
        });
      }
      if (isXiaoMaiAndroidApp()) {
        Bridge.callHandler((Api: any) => {
          Api.openUrl({ url: `xmzj://b/show/detail?broadcastId=${broadcastId}` });
        });
        Bridge.callHandler((Api: any) => {
          Api.exit();
        });
      }
    } else {
      const showUrl: string = `${(CONFIG.appShowUrl as any)[env]}hybird/index.html#/show/activityDetail?broadcastId=${broadcastId}`;
      window.location.href = showUrl;
    }
  }
}